import React from "react";

import PriceTag from "./PriceTag";
import terminology from "terminology.json";

interface Props {
	currency: string;
	price: number;
	locationCountryCode?: string;
	isMenteeSpecific: boolean;

	alternateCurrency: string;
	approxPriceInAlternateCurrency?: number;
}

const SessionTypeVariant: React.FunctionComponent<Props> = ({
	currency,
	price,
	locationCountryCode,
	alternateCurrency,
	approxPriceInAlternateCurrency,
	isMenteeSpecific
}) => {
	const numMeetings = 1;

	return (
		<>
			Single class
			<PriceTag
				currency={currency}
				price={price / numMeetings}
				locationCountryCode={locationCountryCode ? locationCountryCode : "GB"}
				approxPriceInAlternateCurrency={
					approxPriceInAlternateCurrency
						? approxPriceInAlternateCurrency / numMeetings
						: undefined
				}
				alternateCurrency={alternateCurrency}
			/>
			{isMenteeSpecific ? <>{terminology.mentee}-specific price</> : null}
		</>
	);
};

export default SessionTypeVariant;
